module.exports = __webpack_public_path__ + "static/media/moshavere.03d3d6d3.gif";